import React from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

// Types
import { RouteCode } from '@/@types/services/mapService';

export type MapRouteSelectorType = {
  selectedRouteCode: RouteCode;
  onSelectRoute: (c: RouteCode) => void;
  disabled: boolean;
}

const MapRouteSelector = (props: MapRouteSelectorType) => {

  const { selectedRouteCode, onSelectRoute, disabled } = props;

  const { t } = useTranslation();

  return (
    <>
      <Chip
        onClick={() => { onSelectRoute("A"); }}
        sx={{
          backgroundColor: selectedRouteCode === "A" ? "primary.main" : null,
          color: selectedRouteCode === "A" ? "#ffffff" : "#000000",
          transition: "all 0.3s",
          "&:hover": {
            backgroundColor: "primary.dark",
            color: "#ffffff",
          },
        }}
        disabled={disabled}
        component="a"
        clickable
        label={
          <Typography variant="body1">
            {t("route_type.recommended")}
          </Typography>
        }
      />
      <Chip
        onClick={() => { onSelectRoute("B"); }}
        sx={{
          backgroundColor: selectedRouteCode === "B" ? "primary.main" : null,
          color: selectedRouteCode === "B" ? "#ffffff" : "#000000",
          transition: "all 0.3s",
          "&:hover": {
            backgroundColor: "primary.dark",
            color: "#ffffff",
          },
        }}
        disabled={disabled}
        component="a"
        clickable
        label={
          <Typography variant="body1">
            {t("route_type.demanding")}
          </Typography>
        }
      />
    </>
  );
}

export default MapRouteSelector;
